/* Super Socks – Produktgalerie startet mit dem ersten Bild
 *
 * Das Theme (sections.js, Variantenwahl) springt beim Laden auf das Bild der
 * vorausgewählten Größe. Die Galerie soll immer mit dem ersten Bild beginnen
 * (Daniel, 15.10.2026). Dieses Skript lässt diesen ersten, automatischen
 * Sprung nicht zu: Solange niemand Größen, Bilder oder Vorschaubilder berührt
 * hat, ignoriert der Produkt-Slider sofortige Sprünge weg vom ersten Bild.
 * Tippt jemand eine Größe an, springt die Galerie wie bisher zu deren Bild.
 * Das erste Bild ist schon vor dem Start des Sliders das sichtbare Startbild
 * (snippets/product-images.liquid, ss-start).
 */
(function () {
  'use strict';
  if (window.SSGalerie) return;
  window.SSGalerie = true;

  var BEREICH = '.is-product-main .swatch_options, .is-product-main .product__images, .is-product-main .product_gallery_nav';
  var beruehrt = false;
  var schutz = true;

  function merken(e) {
    if (e.target && e.target.closest && e.target.closest(BEREICH)) beruehrt = true;
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (typ) {
    document.addEventListener(typ, merken, { capture: true, passive: true });
  });

  function istProduktGalerie(el) {
    return el && el.matches && el.matches('.is-product-main .product_gallery');
  }

  /* Sofortige Sprünge (isInstant) weg vom ersten Bild beim Laden abfangen.
     Pfeile, Wischen und Vorschaubilder springen nicht sofort; das Neu-
     Ausrichten nach Größenänderung bleibt beim ersten Bild und ist erlaubt. */
  if (window.Flickity && window.Flickity.prototype && !window.Flickity.prototype._ssSelect) {
    var original = window.Flickity.prototype.select;
    window.Flickity.prototype._ssSelect = original;
    window.Flickity.prototype.select = function (index, isWrap, isInstant) {
      if (schutz && !beruehrt && isInstant && index !== 0 && istProduktGalerie(this.element)) return;
      return original.apply(this, arguments);
    };
  }

  /* Sicherheitsnetz, falls der Sprung doch durchkam (z. B. Flickity später geladen) */
  function zumErstenBild() {
    if (beruehrt || !window.Flickity) return;
    var g = document.querySelector('.is-product-main .product_gallery.flickity-enabled');
    var f = g && window.Flickity.data(g);
    if (f && f.selectedIndex !== 0) f.select(0, false, true);
  }

  window.addEventListener('load', function () {
    zumErstenBild();
    setTimeout(function () { zumErstenBild(); schutz = false; }, 3000);
  });
})();
